import React from 'react';
import styled from 'styled-components';
import {COLORS, List} from '@fupa/fupa-uikit';
import {object, bool, oneOfType, string} from 'prop-types';
import {FPHTMLLink} from 'app/components/links/link';

const Link = styled(FPHTMLLink)`
  display: block;
  text-decoration: none;
  color: ${COLORS.black};

  &:focus,
  &:hover {
    background-color: ${COLORS.lightestGrey};
  }
`;

const Container = styled(List)`
  display: flex;
  cursor: pointer;
  span {
    margin-left: 0.75rem;
    color: ${COLORS.black};
  }

  &:hover {
    background-color: ${COLORS.lightestGrey};
  }
`;

const SettingsLinkRow = ({link, icon, label, self = false, ...props}) => {
  const handleClick = () => {
    if (self) {
      window.location = link;
    } else {
      window.open(link, '_blank') || window.location.replace(link);
    }
  };

  const settingsRow = <SettingsRow icon={icon} label={label} />;

  if (link.startsWith('/auth/')) {
    return (
      <Link as='div' tabIndex='0' {...props} onClick={handleClick}>
        {settingsRow}
      </Link>
    );
  } else {
    return (
      <Link {...props} target={self ? '_self' : '_blank'} href={link}>
        {settingsRow}
      </Link>
    );
  }
};

const SettingsRow = ({label, icon, ...props}) => {
  return (
    <Container {...props}>
      {icon}
      <span>{label}</span>
    </Container>
  );
};

SettingsLinkRow.propTypes = {
  link: string.isRequired,
  icon: oneOfType([string, object]).isRequired,
  label: string.isRequired,
  self: bool,
};

SettingsRow.propTypes = {
  icon: oneOfType([string, object]).isRequired,
  label: string.isRequired,
};

export {SettingsLinkRow, SettingsRow};
